import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/bg-header-before-sti-dest.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-right-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4fa08670")

_pushScopeId("data-v-4fa08670")
const _hoisted_1 = {
  class: "flex flex-col",
  style: {"height":"234px"},
  "data-testid": "incoming-sti-dest-header-before"
}
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "absolute top-0 right-0 bottom-0 object-cover h-full",
  src: _imports_0
}, null, -1)
const _hoisted_4 = {
  id: "textContainer",
  class: "flex flex-col w-full pr-2"
}
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "font-montserrat line-height-075 text-20px" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_1
}, null, -1)
const _hoisted_8 = { class: "flex flex-row font-montserrat font-bold text-center" }
const _hoisted_9 = {
  id: "textCargo1",
  class: "cargo-text-container"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  id: "textDivider1",
  class: "content-center mx-1 cargo-text-divider-container"
}, " | ", -1)
const _hoisted_11 = {
  id: "textCargo2",
  class: "cargo-text-container"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  id: "textDivider2",
  class: "content-center mx-1 cargo-text-divider-container"
}, " | ", -1)
const _hoisted_13 = {
  id: "textCargo3",
  class: "cargo-text-container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_skeleton = _resolveComponent("skeleton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("stiDest.dashboard.headerBeforeStiDest")), 1),
    _createVNode("div", {
      class: "background-gradient-blue text-white pl-4 pr-2 py-3 rounded-lg w-full flex justify-between items-center cursor-pointer relative mt-2",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickCard && _ctx.onClickCard(...args))),
      style: {"height":"202px"}
    }, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("stiDest.dashboard.cargoPlaneTruckShip")), 1),
          _hoisted_7
        ]),
        _withDirectives(_createVNode(_component_skeleton, {
          class: "mt-3",
          width: "100%",
          height: "62px"
        }, null, 512), [
          [_vShow, _ctx.isLoading]
        ]),
        _withDirectives(_createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.formatQuantity(_ctx.totalCargoPlane)), 1),
          _hoisted_10,
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.formatQuantity(_ctx.totalCargoTruck)), 1),
          _hoisted_12,
          _createVNode("div", _hoisted_13, _toDisplayString(_ctx.formatQuantity(_ctx.totalCargoShip)), 1)
        ], 512), [
          [_vShow, !_ctx.isLoading]
        ]),
        _withDirectives(_createVNode(_component_skeleton, {
          class: "mt-6",
          width: "340px",
          height: "30px"
        }, null, 512), [
          [_vShow, _ctx.isLoading]
        ]),
        _withDirectives(_createVNode("div", {
          class: "font-montserrat font-semibold mt-6",
          style: {"font-size":"24px"}
        }, _toDisplayString(_ctx.formatQuantity(_ctx.totalSttNeedStiDest)) + " STT ", 513), [
          [_vShow, !_ctx.isLoading]
        ])
      ])
    ])
  ]))
})